import { render, staticRenderFns } from "./payment-success.vue?vue&type=template&id=fb01f342&scoped=true"
import script from "./payment-success.vue?vue&type=script&lang=js"
export * from "./payment-success.vue?vue&type=script&lang=js"
import style0 from "./payment-success.vue?vue&type=style&index=0&id=fb01f342&prod&scoped=true&lang=less"
import style1 from "@/assets/h5css/shop/payment-success.less?vue&type=style&index=1&id=fb01f342&prod&scoped=true&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb01f342",
  null
  
)

export default component.exports